import { NotEqExpression } from "../../../Models/Comparators/NotEqExpression";
import { IExpressionEvaluator } from "../../../Models/IExpressionEvaluator";
import { MaybePromise } from "../../../Models/MaybePromise";
import { IExpressionEvaluatorContext } from "../../../Models/IExpressionEvaluatorContext";
import { EqExpressionEvaluator } from "./EqExpressionEvaluator";

export class NotEqExpressionEvaluator implements IExpressionEvaluator<NotEqExpression> {
  private eqEvaluator = new EqExpressionEvaluator();

  get type(): string {
    return "NotEq";
  }

  evaluate(expression: NotEqExpression, context: IExpressionEvaluatorContext): MaybePromise {
    if (!expression.Value || expression.Value.length === 0) {
      return false;
    }

    const result = this.eqEvaluator.evaluate(expression, context);

    if (result instanceof Promise) {
      return result.then((value) => !value);
    }

    return !result;
  }
}
